import jsPDF from "jspdf";
import dayjs from "dayjs";
import laiSenBale from "./pic/a2.jpg";
import arabicToThai from "../../../../hook/arabicToThai";
import { drawRichText, b } from "./richText";

export async function exportNotifyGuarantor28New(
    dataTabelB,
    selectedContract,
    currentBatchNumber
) {

    const [, , numberToThaiText] = arabicToThai();

    const doc = new jsPDF('p', 'mm', 'a4');

    dataTabelB.forEach((item, index) => {

        let T1, A1, J1;
        J1 = `จ. ${item?.PROVDES}`;
        if (item?.PROVCOD === "01") {
            T1 = `แขวง ${item?.TUMB}`;
            A1 = `เขต ${item?.AUMPDES}`;
        } else {
            T1 = `ต.${item?.TUMB}`;
            A1 = `อ.${item?.AUMPDES}`;
        }

        if (index > 0) doc.addPage();

        let y = 10; // ตำแหน่ง Y เริ่มต้น

        doc.setFont('THSarabunNew', 'normal');
        doc.setFontSize(14);

        // --- ส่วนหัว (ชื่อลูกค้า / ที่อยู่ สำหรับซองจดหมาย) ---
        const address = `
                    ชื่อลูกค้า:     ${item.SNAM + item.NAME1 + ' ' + item.NAME2} (คนค้ำ ${item?.GARNO}) (${item?.CONTNO})
                    ที่อยู่:          ${item?.ADDR1}
                                    ${T1} ${A1} ${J1} ${item?.ZIP}
                    เบอร์โทร:    ${item?.TELP}
                                    (${dayjs(item.roundDate).format('DD/MM/YYYY')})
        `;
        doc.text(address, 5, y);
        doc.text(`${index + 1}/${currentBatchNumber}`, 180, y);
        y += 77;

        // --- วันที่ ---
        const dataNow = dayjs(item.roundDate).format('DD/MM/YYYY'); // วันที่ยึด
        doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
        y += 10;

        // --- เรื่อง / เรียน ---
        const s1 = `
        เรื่อง บอกกล่าวให้ชำระหนี้
        `;
        // const s1 = `
        // เรื่อง แจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ สัญญาเช่าซื้อเลขที่ (${item?.CONTNO})
        // `;
        doc.text(s1, 5, y);
        y += 7;

        const s2 = `
        เรียน ${item.SNAM + item.NAME1 + ' ' + item.NAME2}
        `;
        doc.text(s2, 5, y);
        y += 22;

        // --- ค่าเงินและคำอ่าน ---
        const amount = Number((item?.TOT_UPAY ?? 0) * (item?.EXP_PRD ?? 0)).toLocaleString('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const amountThaiText = numberToThaiText(amount);

        // --- เนื้อหา (ตัวหนาเฉพาะค่าที่ต้องเน้น ผ่าน b() ที่เหลือเป็นตัวปกติ) ---
        const indent = "          "; // ย่อหน้าแรก
        const bodyX = 15;
        const bodyWidth = 175;
        const lineHeight = 7;

        const p1 = [
            `${indent}ตามที่ท่านได้ตกลงทำสัญญาค้ำประกันการเช่าซื้อรถยนต์ยี่ห้อ `,
            b(item.TYPE),
            ` รุ่น `,
            b(item.MODEL),
            ` สี `,
            b(item.COLOR),
            ` เลขตัวถัง `,
            b(item.STRNO),
            ` เลขเครื่อง `,
            b(item.ENGNO),
            ` ทะเบียน `,
            b(`${item.REGNO} ${item.DORECV}`),
            ` ระหว่าง ${item.BSNAM + item.BNAME1 + ' ' + item.BNAME2} ผู้เช่าซื้อกับ บริษัท วัน ลิสซิ่ง จำกัด ผู้ให้เช่าซื้อตามสัญญาเช่าซื้อฉบับลงวันที่ `,
            b(dayjs(item.SDATE).format('DD/MM/YYYY')),
            ` รายละเอียดที่ท่านทราบดีอยู่แล้วนั้น บัดนี้ผู้เช่าซื้อได้ปฏิบัติผิดสัญญา โดยค้างชำระค่าเช่าซื้อ งวดที่ ${item.EXP_FRM} - ${item.EXP_TO} ซึ่งกำหนดชำระ `,
            b(dayjs(item.FirstUnpaidDate).format('DD/MM/YYYY')),
            ` จำนวน ${item.EXP_PRD} งวด ติดต่อกันเป็นจำนวนเงิน `,
            b(`${amount} บาท ${amountThaiText} (รวมภาษีมูลค่าเพิ่ม)`),
            ` ส่วนค่าเบี้ยปรับตามกฎหมาย พร้อมค่าใช้จ่ายในการติดตามอื่นๆ ขอให้ท่านชำระหนี้ที่ค้างทั้งหมดให้แล้วเสร็จภายใน 7 วัน นับจากที่ท่านได้รับหนังสือฉบับนี้`,
        ];

        const p2 = [
            `${indent}หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้เช่าซื้อมีความจำเป็นที่จะต้อง ดำเนินตามกฎหมายต่อไป`,
        ];

        y = drawRichText(doc, bodyX, y, bodyWidth, lineHeight, p1);
        y += lineHeight * 2;
        y = drawRichText(doc, bodyX, y, bodyWidth, lineHeight, p2);

        y += lineHeight * 2;
        doc.text('จึงเรียนมาเพื่อโปรดดำเนินการด่วน', 30, y);

        // --- ส่วนลงนาม ---
        y += 20;
        const signatureImg = laiSenBale;
        doc.addImage(signatureImg, 'PNG', 155, y - 11, 30, 15);
        doc.text('ลงชื่อ....................................', 150, y);
        y += 7;
        doc.text('ผู้ออกจดหมาย', 159, y);

        y += 24;
        doc.text('- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย', 15, y);
    });

    doc.autoPrint();
    return doc.output("bloburl");
}
